import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const HomeLightIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M12.078 12.72a2.913 2.913 0 0 0-2.96 2.912v4.696H4.994a.342.342 0 0 1-.344-.348V9.932c0-.093.045-.206.134-.29l6.97-5.91a.38.38 0 0 1 .47 0l6.97 5.933c.1.092.134.188.134.267v.001l.022 10.047c0 .216-.172.37-.345.37h-4.079v-4.63c0-1.56-1.22-2.971-2.848-3Zm-.012.648Z"
      stroke={color}
      strokeWidth={1.3}
    />
  </Svg>
);

export default HomeLightIcon;
